import service from "@/utils/requestDownload";

export function downloadDataByCategoryApi(data) {
    return service({
        url: '/download/category',
        method: 'post',
        data
    })
}